import CalendarIcon from '@assets/DatePickersIcons/DateIcon.svg'

export const DatePickerCalendarIcon = () => (
  <img
    src={CalendarIcon}
    alt="calendar"
    style={{
      width: 'clamp(18px, 1.25vw, 22px)',
      height: 'clamp(18px, 1.25vw, 22px)',
    }}
  />
)

export default DatePickerCalendarIcon
